import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './MarketItem.css';
import {SocialPostPageHeader} from "./SocialPostPageHeader";
import React, { useState, useEffect } from 'react';

const MarketItem = ({ trackClick, item, with_header = false }) => {
  const { page_id, titre, medias, shop_url, price } = item;
  const [page, setPage] = useState(null);
  const imageUrl = medias && medias.length > 0 ? medias[0] : "https://via.placeholder.com/300";

  const fetchPage = async () => {
    var p = await sdk.models.SocialPages.getOne(page_id);
    setPage(p);
  }

  useEffect(() => {
    fetchPage();
  }, [])

  const recordClick = async () => {
    if (trackClick) {
      trackClick();
    }
  }

  return (
    <>        
        {page && with_header &&
            <SocialPostPageHeader
                page={page}
            />
        }
        <div className="market-item" onClick={recordClick}>
            <div className="image-wrapper">
                <a href={shop_url} target="_blank" rel="noopener noreferrer" className="shop-link">
                    <img src={imageUrl} alt={titre} className="market-image" />
                </a>
                {(price > 0) &&
                  <div className="price">${price}</div>
                }
            </div>
            <div className="item-details">
                <h3 className="item-title">{titre}</h3>
                <a href={shop_url} target="_blank" rel="noopener noreferrer" className="shop-button">
                    Voir la boutique
                </a>
            </div>
        </div>
    </>
  );
};

export { MarketItem };